<template>
  <div id="app">
    <Header />
    <Footer />
  </div>
</template>

<script>
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer
  }
};
</script>

<style>

@font-face {
  font-family: "MetaWebPro";
  src: url("./fonts/ff_meta_web_pro_bold/MetaWebPro-Bold.woff") format("woff"),
       url("./fonts/ff_meta_web_pro_bold/MetaWebPro-Bold.eot"),
       url("./fonts/ff_meta_web_pro_bold/MetaCompPro-Bold.ttf");
  font-weight: 900;
  font-style: normal;
}

@font-face {
  font-family: "MetaWebPro";
  src: url("./fonts/ff_meta_web_thin/MetaWeb-Thin.woff") format("woff"),
         url("./fonts/ff_meta_web_thin/MetaWeb-Thin.eot"),
       url("./fonts/ff_meta_web_thin/MetaComp-Thin.ttf");;
  font-weight: 100;
  font-style: normal;
}

@font-face {
  font-family: "MetaWebPro";
  src: url("./fonts/ff_meta_web_pro_normal/MetaWebPro-Normal.woff") format("woff"),
         url("./fonts/ff_meta_web_pro_normal/MetaWebPro-Normal.eot"),
       url("./fonts/ff_meta_web_pro_normal/MetaCompPro-Normal.ttf");;
  font-weight: 400;
  font-style: normal;
}

html,
body,
#app,
section.section {
  height: 100%;
  color: white;
  font-family: "MetaWebPro", "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.green {
  color: #77bc1f;
  text-decoration: none important!;
}
a:hover {
  text-decoration: none important!;
}

@media (min-width: 1200px) {
  .container {
    max-width: 1200px;
  }
}
</style>
